var _path, _path2, _path3, _path4, _path5, _path6, _g, _path7, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgError401Manhole(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 395,
    height: 149,
    viewBox: "0 0 395 149",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 115.442V88.4403L61.8299 0H99.2018V86.4836H115.246V115.442H99.2018V140.878H65.7432V115.442H0ZM68.0912 36.7849L35.2196 86.4836H68.0912V36.7849Z",
    fill: "url(#paint0_linear)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M228.56 148.14C277.47 148.14 317.12 128.315 317.12 103.86C317.12 79.4046 277.47 59.5798 228.56 59.5798C179.65 59.5798 140 79.4046 140 103.86C140 128.315 179.65 148.14 228.56 148.14Z",
    fill: "#86A5BC"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M228.56 145.56C277.47 145.56 317.12 125.735 317.12 101.28C317.12 76.8248 277.47 57 228.56 57C179.65 57 140 76.8248 140 101.28C140 125.735 179.65 145.56 228.56 145.56Z",
    fill: "url(#paint1_linear)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M174.624 78.2279C204.402 63.3205 252.717 63.3205 282.495 78.2279C296.407 85.1749 303.815 94.1303 304.736 103.233C305.842 92.8405 298.471 82.2634 282.495 74.303C252.717 59.414 204.494 59.414 174.624 74.303C158.721 82.2634 151.314 92.8405 152.382 103.233C153.304 94.1303 160.711 85.1749 174.624 78.2279Z",
    fill: "url(#paint2_linear)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M174.624 128.257C204.402 143.146 252.718 143.146 282.495 128.257C296.408 121.31 303.815 112.281 304.737 103.233C303.815 94.1304 296.408 85.1749 282.495 78.2279C252.718 63.3205 204.494 63.3205 174.624 78.2279C160.712 85.1749 153.304 94.1304 152.383 103.233C153.304 112.281 160.712 121.31 174.624 128.257Z",
    fill: "url(#paint3_linear)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M228.9 140.968C273.627 140.968 309.886 122.839 309.886 100.475C309.886 78.1109 273.627 59.9814 228.9 59.9814C184.172 59.9814 147.913 78.1109 147.913 100.475C147.913 122.839 184.172 140.968 228.9 140.968Z",
    fill: "url(#paint4_linear)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.9
  }, /*#__PURE__*/React.createElement("path", {
    d: "M228.256 131.803C261.871 131.803 289.122 117.769 289.122 100.457C289.122 83.1454 261.871 69.1113 228.256 69.1113C194.641 69.1113 167.39 83.1454 167.39 100.457C167.39 117.769 194.641 131.803 228.256 131.803Z",
    fill: "#476073"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.288 77.0519C151.478 89.9177 152.693 109.163 180.149 122.704C207.605 136.246 248.728 135.57 276.538 122.704C304.347 109.839 306.859 91.8636 279.403 78.3385C251.947 64.8134 207.114 64.2183 179.288 77.0519ZM239.525 76.8268C240.065 75.9101 242.07 75.3794 244.026 75.6528C245.981 75.9262 247.144 76.9072 246.537 77.84C245.93 78.7727 243.975 79.3034 242.02 79.03C240.065 78.7566 238.986 77.84 239.525 76.8268ZM193.9 120.249C193.08 120.583 192.197 120.756 191.305 120.756C190.413 120.756 189.53 120.583 188.709 120.249C187.294 119.541 187.294 118.431 188.709 117.772C189.528 117.43 190.411 117.254 191.305 117.254C192.198 117.254 193.082 117.43 193.9 117.772C195.367 118.448 195.35 119.557 193.9 120.233V120.249ZM218.508 126.312C217.969 127.228 215.946 127.759 213.991 127.486C212.036 127.212 210.89 126.247 211.429 125.315C211.968 124.382 213.991 123.851 215.946 124.125C217.901 124.398 219.047 125.363 218.508 126.296V126.312ZM181.327 107.013C181.833 107.962 180.67 108.895 178.698 109.136C176.726 109.377 174.737 108.782 174.215 107.833C173.692 106.884 174.889 105.952 176.844 105.727C178.799 105.501 180.805 106.112 181.327 107.045V107.013ZM245.93 125.733C246.453 126.666 245.273 127.614 243.318 127.84C241.362 128.065 239.34 127.486 238.834 126.553C238.329 125.62 239.492 124.655 241.48 124.478C243.469 124.301 245.424 124.784 245.93 125.733ZM181.496 94.871C180.956 95.8038 178.934 96.3345 176.979 96.0611C175.024 95.7877 173.877 94.8067 174.417 93.8739C174.956 92.9412 176.979 92.4265 178.934 92.6999C180.889 92.9733 182.035 93.9222 181.496 94.871ZM268.785 121.165C267.966 121.507 267.082 121.684 266.189 121.684C265.296 121.684 264.412 121.507 263.593 121.165C262.178 120.474 262.195 119.364 263.593 118.689C264.414 118.354 265.297 118.182 266.189 118.182C267.081 118.182 267.964 118.354 268.785 118.689C270.251 119.396 270.234 120.506 268.785 121.165ZM194.389 84.498C193.57 84.8361 192.686 85.0105 191.794 85.0105C190.901 85.0105 190.018 84.8361 189.198 84.498C187.782 83.7904 187.799 82.6807 189.198 82.0213C190.017 81.6795 190.9 81.503 191.794 81.503C192.687 81.503 193.571 81.6795 194.389 82.0213C195.856 82.6646 195.839 83.8386 194.389 84.498ZM283.617 109.249C283.077 110.165 281.055 110.696 279.1 110.423C277.144 110.149 275.998 109.168 276.538 108.251C277.077 107.335 279.1 106.788 281.055 107.061C283.01 107.335 284.156 108.396 283.617 109.249ZM219.199 76.5695C219.705 77.5183 218.542 78.4672 216.57 78.6923C214.598 78.9175 212.609 78.3385 212.103 77.3897C211.598 76.4408 212.761 75.508 214.716 75.2829C216.671 75.0577 218.693 75.6367 219.199 76.5695ZM283.802 95.257C284.324 96.2059 283.145 97.1386 281.189 97.3638C279.234 97.5889 277.212 97.01 276.706 96.0772C276.201 95.1444 277.364 94.1956 279.336 93.9704C281.307 93.7453 283.296 94.3242 283.802 95.257ZM269.29 85.4468C268.47 85.7813 267.587 85.9537 266.695 85.9537C265.803 85.9537 264.92 85.7813 264.099 85.4468C262.666 84.7392 262.683 83.6296 264.099 82.9702C264.918 82.6283 265.801 82.4518 266.695 82.4518C267.588 82.4518 268.472 82.6283 269.29 82.9702C270.74 83.6617 270.723 84.7714 269.29 85.4468Z",
    fill: "#849FB4"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M179.321 75.3492C151.495 88.215 151.208 109.572 178.664 123.097C206.12 136.622 250.936 137.201 278.762 124.368C306.589 111.534 306.892 90.1449 279.42 76.6036C251.947 63.0624 207.148 62.4995 179.321 75.3492ZM239.559 75.2045C240.082 74.2717 242.104 73.7571 244.059 74.0305C246.014 74.3039 247.16 75.2688 246.621 76.2016C246.082 77.1344 244.076 77.6651 242.121 77.3917C240.166 77.1183 239.02 76.0568 239.559 75.2045ZM193.934 118.626C193.116 118.968 192.232 119.145 191.339 119.145C190.445 119.145 189.561 118.968 188.743 118.626C187.31 117.935 187.327 116.825 188.743 116.15C189.563 115.815 190.446 115.643 191.339 115.643C192.231 115.643 193.114 115.815 193.934 116.15C195.384 116.745 195.367 117.855 193.934 118.514V118.626ZM218.542 124.689C218.002 125.622 215.98 126.153 214.025 125.88C212.069 125.606 210.923 124.625 211.463 123.708C212.002 122.792 214.025 122.245 215.98 122.518C217.935 122.792 219.081 123.66 218.542 124.577V124.689ZM181.361 105.391C181.866 106.324 180.687 107.272 178.731 107.498C176.776 107.723 174.771 107.144 174.248 106.211C173.726 105.278 174.922 104.313 176.877 104.088C178.833 103.863 180.805 104.394 181.361 105.343V105.391ZM245.964 124.03C246.486 124.963 245.306 125.912 243.334 126.137C241.362 126.362 239.374 125.783 238.868 124.834C238.362 123.885 239.525 122.953 241.48 122.727C243.436 122.502 245.458 123.081 245.964 124.03ZM181.529 93.1683C180.99 94.1011 178.967 94.6318 177.012 94.3584C175.057 94.085 173.911 93.104 174.45 92.1712C174.99 91.2385 177.012 90.7238 178.967 90.9972C180.923 91.2706 182.069 92.2356 181.529 93.1683ZM268.818 119.463C267.999 119.801 267.116 119.975 266.223 119.975C265.33 119.975 264.447 119.801 263.627 119.463C262.211 118.755 262.228 117.645 263.627 116.986C264.447 116.648 265.33 116.474 266.223 116.474C267.116 116.474 267.999 116.648 268.818 116.986C270.285 117.694 270.268 118.803 268.818 119.463ZM194.423 82.7953C193.602 83.1297 192.72 83.3022 191.827 83.3022C190.935 83.3022 190.052 83.1297 189.232 82.7953C187.816 82.0877 187.833 80.978 189.232 80.3186C190.05 79.9768 190.934 79.8003 191.827 79.8003C192.721 79.8003 193.604 79.9768 194.423 80.3186C195.974 81.0102 195.872 82.1198 194.423 82.7953ZM283.616 107.53C283.077 108.463 281.055 108.993 279.099 108.72C277.144 108.446 275.998 107.465 276.538 106.549C277.077 105.632 279.099 105.085 281.055 105.359C283.01 105.632 284.19 106.613 283.616 107.53ZM219.233 74.8668C219.738 75.8156 218.558 76.7645 216.603 76.9896C214.648 77.2148 212.643 76.6358 212.12 75.687C211.598 74.7381 212.828 73.8053 214.749 73.5963C216.671 73.3872 218.71 73.934 219.233 74.8668ZM283.836 93.5543C284.358 94.4871 283.178 95.4359 281.223 95.6611C279.268 95.8862 277.245 95.3073 276.74 94.3745C276.234 93.4417 277.397 92.4768 279.369 92.2516C281.341 92.0265 283.33 92.6054 283.836 93.5543ZM269.324 83.7281C268.505 84.0699 267.622 84.2464 266.728 84.2464C265.835 84.2464 264.951 84.0699 264.133 83.7281C262.7 83.0365 262.717 81.9269 264.133 81.2514C264.953 80.917 265.836 80.7445 266.728 80.7445C267.621 80.7445 268.503 80.917 269.324 81.2514C270.773 81.959 270.757 83.0687 269.324 83.7281Z",
    fill: "url(#paint5_linear)"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_i)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M260.811 100.273C260.927 91.9068 246.806 84.9448 229.27 84.7229C211.735 84.5009 197.425 91.103 197.309 99.4691C197.192 107.835 211.314 114.797 228.849 115.019C246.385 115.241 260.694 108.639 260.811 100.273Z",
    fill: "#BFD4E4"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M259.496 100.256C259.608 92.2367 246.071 85.5629 229.262 85.3502C212.452 85.1374 198.735 91.4662 198.623 99.4859C198.512 107.506 212.048 114.179 228.858 114.392C245.667 114.605 259.385 108.276 259.496 100.256Z",
    fill: "#F2F7F9"
  }))), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M336 35.4911V0H395V141H355.731V35.4911H336Z",
    fill: "url(#paint6_linear)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d",
    x: 156.434,
    y: 65.4595,
    width: 145.222,
    height: 71.2131,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.21732
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.912989
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.517647 0 0 0 0 0.623529 0 0 0 0 0.705882 0 0 0 0.3 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_i",
    x: 197.308,
    y: 84.7175,
    width: 63.5033,
    height: 30.3071,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.608659
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.517647 0 0 0 0 0.623529 0 0 0 0 0.705882 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 25.0985,
    y1: -37.7326,
    x2: 118.459,
    y2: 170.451,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8DA5B7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#748C9E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear",
    x1: 139.993,
    y1: 101.287,
    x2: 317.12,
    y2: 101.287,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B7CDDD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A1BACD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear",
    x1: 152.272,
    y1: 83.1847,
    x2: 304.847,
    y2: 83.1847,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BFD4E4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#BDD3E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#BCD2E2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#BBD1E2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#BBD1E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B5C5D1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear",
    x1: 227.325,
    y1: 67.0059,
    x2: 229.794,
    y2: 139.461,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7992A4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#627889"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#415463"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear",
    x1: 168.912,
    y1: 75.8066,
    x2: 282.122,
    y2: 131.195,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BFD4E4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B9CFE0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear",
    x1: 188.389,
    y1: 72.1547,
    x2: 275.427,
    y2: 124.804,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F2F7F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E2EDF1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear",
    x1: 338.73,
    y1: -35.0751,
    x2: 431.188,
    y2: 169.676,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8DA5B7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#748C9E"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgError401Manhole);
export default __webpack_public_path__ + "static/media/error_401_manhole.3ff718bc5c21c70248480a7edda4caa8.svg";
export { ForwardRef as ReactComponent };